module.exports = __webpack_public_path__ + "img/5e1ce16.svg";